import { Pipe, PipeTransform, inject } from '@angular/core';
import { LibraryId } from '../model/library';
import { LibraryService } from '../library.service';

@Pipe({
  name: 'libraryName',
  pure: false,
  standalone: true
})
export class LibraryNamePipe implements PipeTransform {
  private libraryService = inject(LibraryService);

  private libraryId: LibraryId;
  private libraryName = '';

  transform(libraryId: LibraryId): string {
    if (!libraryId || libraryId === this.libraryId) {
      return this.libraryName;
    }

    this.libraryId = this.libraryName = libraryId;
    this.libraryService.getLibrary(libraryId).then(library => {
      this.libraryName = library?.displayName ?? libraryId;
    });

    return this.libraryName;
  }

}
